import request from '@/utils/request'

export function getChannelList(data) {
    return request({
        url: '/backend/channel/getChannelList',
        method: 'post',
        data: data
    })
}
export function createUpdateChannel(data) {
    return request({
        url: '/backend/channel/createUpdateChannel',
        method: 'post',
        data: data
    })
}
export function getChannelItemList(data) {
    return request({
        url: '/backend/channel/getChannelItemList',
        method: 'post',
        data: data
    })
}
export function createUpdateChannelItem(data) {
    return request({
        url: '/backend/channel/createUpdateChannelItem',
        method: 'post',
        data: data
    })
}
export function deleteChannel(data) {
    return request({
        url: '/backend/channel/deleteChannel',
        method: 'post',
        data: data
    })
}
export function deleteChannelItem(data) {
    return request({
        url: '/backend/channel/deleteChannelItem',
        method: 'post',
        data: data
    })
}
export function getItemData(data) {
    return request({
        url: '/backend/channel/getItemData',
        method: 'post',
        data: data
    })
}

export function channelOrderList(data) {
    return request({
        url: '/backend/channel/channelOrderList',
        method: 'post',
        data: data
    })
}